import { useState, useEffect } from 'react';

import { isMobile as isMobileFn } from 'core/use-cases/app/helpers';

export const useResize = () => {
  const [isMobile, setIsMobile] = useState(isMobileFn());

  useEffect(() => {
    function updateSize() {
      setIsMobile(isMobileFn());
    }

    window.addEventListener('resize', updateSize);

    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return [isMobile];
};
